import { AddCircleIcon } from '@synergy/theme-next';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { MouseEvent } from 'react';
import { tokens } from '@synergy/theme-palo';

interface PoolAutocompleteListFooterProps {
    url: string;
    text: string;
}

/** Create-new action strip at the bottom of an autocomplete dropdown (PALO styled). */
export const PoolAutocompleteListFooter = (props: PoolAutocompleteListFooterProps) => {
    return (
        <Box
            component="a"
            href={props.url}
            onMouseDown={(event: MouseEvent<HTMLElement>) => event.preventDefault()}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '5px',
                padding: '7px 12px',
                borderTop: `1px solid ${tokens.color.line}`,
                backgroundColor: tokens.color.surfaceAlt,
                color: tokens.color.accent,
                fontSize: '12px',
                fontWeight: 560,
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': { backgroundColor: tokens.color.accentSoft },
                '& svg': { fontSize: 15 },
            }}
        >
            <AddCircleIcon color="inherit" />
            <FormattedMessage id={props.text} />
        </Box>
    );
};
